/* eslint fp/no-mutation: 0, fp/no-this: 0 */
import { fabric } from "fabric";

fabric.StaticCanvas.prototype.toBlob = function () {
  this.lowerCanvasEl.toBlob(...arguments);
};
